<template>
  <nav class="flex space-x-4" aria-label="Tabs">
    <label
      v-for="option in options"
      :key="option.value"
      class="px-3 py-1 font-medium text-xs rounded-md"
      :class="[
        value.indexOf(option.value) >= 0
          ? 'bg-blue-600 text-white hover:bg-blue-500'
          : 'bg-gray-100 text-gray-700',
      ]"
    >
      <input type="checkbox" :value="option.value" v-model="inputValue" class="hidden" />
      <span>{{ option.label }}</span>
    </label>
  </nav>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: [
        {
          label: 'Total',
          value: 'total',
        },
        {
          label: 'Unique',
          value: 'unique',
        },
        {
          label: 'Organic',
          value: 'organic',
        },
        {
          label: 'Paid',
          value: 'paid',
        },
        {
          label: 'Reactions',
          value: 'reactions',
        },
        {
          label: 'Checkin',
          value: 'checkin',
        },
      ],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
